import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'cftIsBlob',
})
export class IsBlobPipe implements PipeTransform {
  transform(src: string | undefined): boolean {
    return !!src?.startsWith('blob:')
  }
}
